import { useAuthStore } from '@/stores/authStore';

/**
 * Hook to check if severity categories are enabled for the current school.
 * Returns true if enabled (default), false if disabled.
 *
 * When severity is disabled:
 * - All severity UI elements (Minor/Major toggles, badges, counts) are hidden
 * - Behavior category forms show single "Require Notes" checkbox
 * - Reports hide severity columns
 * - Behavior records still store severity in DB (using category default)
 */
export function useSeverityEnabled(): boolean {
  const tenant = useAuthStore((state) => state.tenant);
  return tenant?.settings?.severityEnabled !== false;
}
